import { allocationAPI } from '../../helper/apis';

export const listCategories = () => allocationAPI.get(`/service-categories`);
